function Nav() {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <div className="container-fluid">
                <a className="navbar-brand mb-0 h1" href="/">Blog Application</a>
            </div>
        </nav>
    );
}

export default Nav;